export default "__VITE_ASSET__0Ls5g5Ox__"